export const homeTranslations = {
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      cnc: 'CNC',
      harness: 'Harness Tooling',
      automation: 'Automation',
      contact: 'Contact',
      getQuote: 'Get Quote'
    },
    hero: {
      badge: '15+ Years of Engineering Excellence',
      title1: 'Industrial solutions in',
      titleCNC: 'CNC machining',
      titleHarness: 'wire harness industry tooling',
      titleAnd: 'and',
      titleAuto: 'automated test stations',
      subtitle: 'More than 15 years designing, manufacturing, and integrating assembly and testing equipment for advanced manufacturing industries.',
      cta1: 'Request a Quote',
      cta2: 'Schedule a Call',
      trust1: 'Full integration',
      trust2: 'Short lead times',
      trust3: 'Certified quality'
    },
    services: {
      title: 'Main Service',
      titleAccent: 'Areas',
      service1: {
        title: 'Precision CNC Machining',
        description: 'Specialists in G10, FR4, phenolics, aluminum, and engineering plastics. Prototypes, tooling, spare parts, and small-to-medium batch production.'
      },
      service2: {
        title: 'Fixtures & Tooling for the Wire Harness Industry',
        description: 'Custom assembly fixtures, routing holders, electrical test tooling, and Dynalab-certified integration for harness manufacturing.'
      },
      service3: {
        title: 'Automation & Testing Stations',
        description: 'Custom assembly stations, electrical test systems, and Leak Test integration. Mitsubishi, Siemens, and Keyence PLC integration.'
      },
      learnMore: 'Learn More'
    },
    differentiators: {
      title: 'Why Choose',
      titleAccent: 'DSI',
      subtitle: 'More than a decade developing high-precision industrial solutions for the most demanding manufacturing companies in North America.',
      items: [
        'Mechanical, electrical, and CNC capabilities fully in-house',
        'Short lead times and flexible engineering',
        'Experience with automotive and high-volume manufacturing',
        'Dynalab specialized integrators',
        'Expert machining of difficult materials: G10, FR4, phenolics',
        'Equipment designed for continuous industrial operation'
      ]
    },
    industries: {
      title: 'Industries',
      titleAccent: 'We Serve',
      description: 'Wire harness manufacturing, automotive, electronics, appliances, industrial machinery, and Data Center Power Systems & Solutions Manufacturers.',
      list: [
        'Wire Harness Manufacturing',
        'Automotive',
        'Electronics',
        'Appliances',
        'Industrial Machinery',
        'Data Center Power Systems & Solutions Manufacturers'
      ],
      stats: {
        years: 'Years of Experience',
        projects: 'Projects Completed',
        satisfaction: 'Client Satisfaction'
      }
    },
    cta: {
      title: 'Ready to support your',
      titleAccent: 'next project?',
      subtitle: 'Contact us today to discover how we can optimize your manufacturing processes with our precision engineering solutions.',
      button1: 'Request a Quote',
      button2: 'Contact DSI',
      email: 'Sales Email',
      emailAddress: 'sales@dsidurango.com',
      phone: 'Immediate Assistance',
      phoneDesc: 'Contact us by phone or WhatsApp'
    },
    footer: {
      description: 'Industrial Devices & Solutions - More than 15 years in CNC machining, harness tooling, and automation.',
      emailAddress: 'sales@dsidurango.com',
      quickLinks: 'Quick Links',
      locations: 'Our Locations',
      contact: 'Contact',
      links: [
        'CNC Machining',
        'Harness Fixtures',
        'Automation',
        'Request Quote'
      ],
      copyright: 'DSI Durango - Industrial Devices & Solutions. All rights reserved.',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service'
    }
  },
  es: {
    nav: {
      home: 'Inicio',
      services: 'Servicios',
      cnc: 'CNC',
      harness: 'Arneses',
      automation: 'Automatización',
      contact: 'Contacto',
      getQuote: 'Cotizar ahora'
    },
    hero: {
      badge: 'Más de 15 años de experiencia',
      title1: 'Soluciones industriales en',
      titleCNC: 'maquinado CNC',
      titleHarness: 'fixturas y equipos para industria arnesera',
      titleAnd: 'y',
      titleAuto: 'automatización',
      subtitle: 'Más de 15 años diseñando, fabricando e integrando equipos de ensamble y prueba para la industria manufacturera.',
      cta1: 'Cotizar un proyecto',
      cta2: 'Agendar videollamada',
      trust1: 'Integración completa',
      trust2: 'Entregas rápidas',
      trust3: 'Calidad certificada'
    },
    services: {
      title: 'Áreas principales de',
      titleAccent: 'servicio',
      service1: {
        title: 'Maquinado CNC de precisión',
        description: 'Especialistas en G10, FR4, fenólicos, aluminio y plásticos de ingeniería. Prototipos, herramentales y producción de lotes pequeños y medianos.'
      },
      service2: {
        title: 'Fixtures y dispositivos para la industria arnesera',
        description: 'Fabricación de fixtures, holders y dispositivos para ensamble, ruteo y pruebas eléctricas. Integradores especializados Dynalab.'
      },
      service3: {
        title: 'Automatización y estaciones de prueba',
        description: 'Diseño e integración de estaciones de ensamble, prueba eléctrica y Leak Test. PLC Mitsubishi, Siemens y Keyence.'
      },
      learnMore: 'Ver más'
    },
    differentiators: {
      title: 'Por qué elegir',
      titleAccent: 'DSI',
      subtitle: 'Más de una década desarrollando soluciones industriales de alta precisión para las empresas más exigentes de México.',
      items: [
        'Ingeniería mecánica + eléctrica + CNC en una sola empresa',
        'Tiempos de entrega cortos',
        'Experiencia real en industria automotriz y manufactura avanzada',
        'Integradores especializados Dynalab',
        'Capacidad para materiales de alta complejidad (G10, FR4, fenólicos)',
        'Maquinaria y equipos diseñados para operación continua'
      ]
    },
    industries: {
      title: 'Industrias que',
      titleAccent: 'confían en nosotros',
      description: 'Fabricantes de arneses, automotriz, electrónica, electrodomésticos, maquinaria industrial y fabricantes de Sistemas de alimentación para centros de datos.',
      list: [
        'Arneses Automotrices',
        'Automotriz',
        'Electrónica',
        'Electrodomésticos',
        'Maquinaria Industrial',
        'Fabricantes de Sistemas de alimentación para centros de datos'
      ],
      stats: {
        years: 'Años de experiencia',
        projects: 'Proyectos completados',
        satisfaction: 'Satisfacción del cliente'
      }
    },
    cta: {
      title: 'Listos para apoyar tu siguiente',
      titleAccent: 'proyecto industrial',
      subtitle: 'Contáctanos hoy y descubre cómo podemos optimizar tus procesos de manufactura con nuestras soluciones de ingeniería de precisión.',
      button1: 'Solicitar cotización',
      button2: 'Contactar a DSI',
      email: 'Email de ventas',
      emailAddress: 'ventas@dsidurango.com',
      phone: 'Atención inmediata',
      phoneDesc: 'Contáctanos por teléfono o WhatsApp'
    },
    footer: {
      description: 'Dispositivos y Soluciones Industriales - Más de 15 años en maquinado CNC, herramentales arneseros y automatización.',
      emailAddress: 'ventas@dsidurango.com',
      quickLinks: 'Enlaces rápidos',
      locations: 'Nuestras ubicaciones',
      contact: 'Contacto',
      links: [
        'Maquinado CNC',
        'Arneses y Fixtures',
        'Automatización',
        'Cotizar proyecto'
      ],
      copyright: 'DSI Durango - Dispositivos y Soluciones Industriales. Todos los derechos reservados.',
      privacy: 'Política de Privacidad',
      terms: 'Términos de Servicio'
    }
  }
};